import { CustomInput } from "../../../Common/CustomInputs";
import { CustomDropdown } from "../../../Common/CustomDropdown";
import ComplianceDocumentField from "./ComplianceDocumentField";
import {
  SectionHeader,
  FormRow,
  FieldLabel,
  FormFieldBoxRoot,
} from "../../shared/practitionerForm.styles";
import { colors } from "../../../../theme/theme";
import * as C from "../IPHCPractitionerModal.constants";

const PhysicalOfficeSection = ({
  submitData,
  updateField,
  handleFileChange,
  handleFileDelete,
}) => {
  const renderCell = (cell) => {
    if (cell.type === "input") {
      return (
        <FormFieldBoxRoot key={cell.fieldName}>
          <CustomInput
            value={submitData[cell.fieldName]}
            setValue={(value) => updateField(cell.fieldName, value)}
            placeholder={cell.placeholder}
            label={cell.label}
            smallBr
            bR="14px"
            width="100%"
            noIcon
            color={colors.primary}
          />
        </FormFieldBoxRoot>
      );
    }
    if (cell.type === "dropdown") {
      return (
        <FormFieldBoxRoot key={cell.fieldName}>
          <FieldLabel sx={{ mb: 1 }}>{cell.label}</FieldLabel>
          <CustomDropdown
            value={submitData[cell.fieldName]}
            setValue={(value) => updateField(cell.fieldName, value)}
            placeholder={cell.placeholder}
            data={C.YES_NO_OPTIONS}
            noIcon
            color={colors.primary}
            width="100%"
          />
        </FormFieldBoxRoot>
      );
    }
    if (cell.type === "file") {
      return (
        <FormFieldBoxRoot key={cell.fieldName}>
          <ComplianceDocumentField
            label={cell.label}
            id={`file-input-${cell.fieldName}`}
            file={submitData[cell.fieldName]}
            onChange={(e) => handleFileChange(e, cell.fieldName, cell.multiple)}
            onDelete={(file, index) => handleFileDelete(cell.fieldName, index)}
            uploadLabel={cell.uploadLabel}
            multiple={cell.multiple}
          />
        </FormFieldBoxRoot>
      );
    }
    return null;
  };

  return (
    <>
      <SectionHeader sx={{ mt: 4, mb: 3 }}>
        {C.PHYSICAL_OFFICE_SECTION_TITLE}
      </SectionHeader>

      {C.PHYSICAL_OFFICE_ROWS.map((row, idx) => (
        <FormRow key={idx}>
          {renderCell(row.left)}
          {renderCell(row.right)}
        </FormRow>
      ))}
    </>
  );
};

export default PhysicalOfficeSection;
